module.exports = __webpack_public_path__ + "static/media/materials.cd9771fa.md";